import { Link } from "react-router-dom";
import { getDB } from "../util/db.js"
import { useEffect, useState } from "react";
import { ButtonGroup, Button, Row, Col } from "react-bootstrap";
import { Eye, Search, PlusLg } from "react-bootstrap-icons";
import { LoadingComponent } from "../components/LoadingComponent.js";
import { Api } from "../util/Api.js";
import { useProfile } from "../components/ProfileContext.js";
import { User } from "../models/User.js";
import { useNavigate } from "react-router";
import { pageReadyCondition, setNavAdvisoryLockout } from "../util/utils.js";
import { Inspection } from "../models/Inspection.js";

export function DashboardPage(props) {
	setNavAdvisoryLockout(false);

	let [allInspectionCount, setAllInspectionCount] = useState(null);
	let [completedInspectionCount, setCompletedInspectionCount] = useState(null);
	let [unsynchronizedInspectionCount, setUnsynchronizedInspectionCount] = useState(null);
	let [inProgressInspectionCount, setInProgressInspectionCount] = useState(null);

	let [profile, setProfile] = useProfile();
	let navigate = useNavigate();

	let checkLoginStatus = async () => {
		if(navigator.onLine) {
			console.log("Checking login status..");
			if(!(await Api.forProfile(profile).verifyLoginStatus())) {
				await User.saveUser(null);
				setProfile(null);
				navigate("/login");
			}	
		
			if(profile.needsInspectorRecheck) {
				try {
					let details = await Api.verifyMcElroyId(profile.inspectorIdentifier);
					profile.loadInspectorDetails(details);
					await User.saveUser(profile);
					setProfile(profile);
				} catch(err) {
					// Do nothing
					console.log("Error checking MCID status: " + err);
				}
			}
		}
	};

	// Load an inspection count
	useEffect(async () => {
		console.log("Loading inspections");
		let db = await getDB();

		let allInspections = await db.getAll("Inspections");
		allInspections = allInspections.filter(i => i.syncStatus != "READONLY");
		setAllInspectionCount(allInspections.length);

		let unsavedInspections = allInspections.filter(x => Inspection.syncNeededFor(x));
		setUnsynchronizedInspectionCount(unsavedInspections.length);

		let inProgressInspections = allInspections.filter(x => (x.result != "PASS" && x.result != "FAIL"));
		setInProgressInspectionCount(inProgressInspections.length);
		setCompletedInspectionCount(allInspections.length - inProgressInspections.length);
	});

	// Check login status
	useEffect(() => {
		// perform immediately on hitting page
		checkLoginStatus();
		// perform every X milliseconds
		let intervalManager = setInterval(checkLoginStatus, 3600000);
	}, []); // only run this function on first mount

	let pageCondition = pageReadyCondition(
		completedInspectionCount != null,
		unsynchronizedInspectionCount != null,
		allInspectionCount != null,
		inProgressInspectionCount != null
	);

	let goToInProgressInspections = () => {
		navigate("/inspections?mode=in_progress");
	};

	let goToCompletedInspections = () => {
		navigate("/inspections?mode=completed");
	};

	let goToUnsynchronizedInspections = () => {
		navigate("/inspections?mode=unsynchronized");
	};

    return (
        <div className="dashboardContainer">
            
            <h2 className="textAlignLeft">Status</h2>

            <div>
				{pageCondition != "ready" && <LoadingComponent />}
				{pageCondition == "ready" && <>
					{/* <table className="dashboard-table">
						<tbody>
							<tr><th>Active Job</th><td>{profile.job?.name || "None"}</td></tr>
							<tr><th>In Progress</th><td>{inProgressInspectionCount}</td></tr>
							<tr><th>Completed</th><td>{completedInspectionCount}</td></tr>
							<tr><th>Unsynchronized</th><td>{unsynchronizedInspectionCount}</td></tr>
						</tbody>
					</table> */}
					<div className="jobLink">
						<Link to="/jobs" >
							<div className="activeJobButton">
								<h4>{profile.job?.name || "No Active Job"}</h4>
							</div>
						</Link>
					</div>
					<div className="jobStats" onClick={goToInProgressInspections}>
						<p>In Progress</p>
						<p>{inProgressInspectionCount}</p>
					</div>
					<div className="jobStats" onClick={goToCompletedInspections}>
						<p>Completed</p>
						<p>{completedInspectionCount}</p>
					</div>
					<div className="jobStats" onClick={goToUnsynchronizedInspections}>
						<p>Pending Upload</p>
						<p>{unsynchronizedInspectionCount}</p>
					</div>
				
				</>}
            </div>
            
			{/* <h3 className="subHeading">Assets</h3>
			<div className="assetContainer">
				<Link to="/assets"><Eye className="inspectionIcon"/><br></br>View Assets</Link>
			</div> */}
			
        </div>
    );
}